import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Layout
import Navigation from './components/Navigation';
import Login from './components/Login';

// Utilisateurs
import ListeUtilisateurs from './components/utilisateurs/ListeUtilisateurs';
import FormulaireUtilisateur from './components/utilisateurs/FormulaireUtilisateur';

// Centres
import ListeCentres from './components/centres/ListeCentres';
import FormulaireCentre from './components/centres/FormulaireCentre';

// Pointage
import Pointage from './components/pointage/Pointage';
import ConsultationPointages from './components/pointage/ConsultationPointages';

// Types d'intervention
import ListeTypesIntervention from './components/typesIntervention/ListeTypesIntervention';
import FormulaireTypeIntervention from './components/typesIntervention/FormulaireTypeIntervention';

// Interventions
import ListeInterventions from './components/interventions/ListeInterventions';
import FormulaireIntervention from './components/interventions/FormulaireIntervention';
import AgendaTechnicien from './components/interventions/AgendaTechnicien';
import AgendaGlobal from './components/interventions/AgendaGlobal';

// Réalisation (Mobile)
import RealisationIntervention from './components/realisation/RealisationIntervention';

// Statistiques
import StatistiquesTechnicien from './components/statistiques/StatistiquesTechnicien';
import StatistiquesGlobales from './components/statistiques/StatistiquesGlobales';

// Tableau de bord
import TableauDeBord from './components/dashboard/TableauDeBord';
import TableauDeBordTechnicien from './components/dashboard/TableauDeBordTechnicien';

// Produits et stocks
import ListeProduits from './components/produits/ListeProduits';
import FormulaireProduit from './components/produits/FormulaireProduit';
import GestionStock from './components/stocks/GestionStock';
import AlertesStock from './components/stocks/AlertesStock';

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  const handleLogin = (user) => {
    setCurrentUser(user);
  };

  const handleLogout = () => {
    setCurrentUser(null);
  };

  if (!currentUser) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="app">
        <Navigation user={currentUser} onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            {/* Dashboard */}
            <Route path="/" element={
              currentUser.role === 'admin' 
                ? <TableauDeBord user={currentUser} />
                : <TableauDeBordTechnicien user={currentUser} />
            } />
            
            {/* Utilisateurs (Admin) */}
            <Route path="/utilisateurs" element={<ListeUtilisateurs user={currentUser} />} />
            <Route path="/utilisateurs/nouveau" element={<FormulaireUtilisateur user={currentUser} />} />
            <Route path="/utilisateurs/:id/modifier" element={<FormulaireUtilisateur user={currentUser} />} />
            
            {/* Centres */}
            <Route path="/centres" element={<ListeCentres user={currentUser} />} />
            <Route path="/centres/nouveau" element={<FormulaireCentre user={currentUser} />} />
            <Route path="/centres/:id/modifier" element={<FormulaireCentre user={currentUser} />} />
            
            {/* Pointage */}
            <Route path="/pointage" element={<Pointage user={currentUser} />} />
            <Route path="/pointages" element={<ConsultationPointages user={currentUser} />} />
            
            {/* Types d'intervention */}
            <Route path="/types-intervention" element={<ListeTypesIntervention user={currentUser} />} />
            <Route path="/types-intervention/nouveau" element={<FormulaireTypeIntervention user={currentUser} />} />
            <Route path="/types-intervention/:id/modifier" element={<FormulaireTypeIntervention user={currentUser} />} />
            
            {/* Interventions */}
            <Route path="/interventions" element={<ListeInterventions user={currentUser} />} />
            <Route path="/interventions/nouvelle" element={<FormulaireIntervention user={currentUser} />} />
            <Route path="/interventions/:id/modifier" element={<FormulaireIntervention user={currentUser} />} />
            
            {/* Agendas */}
            <Route path="/agenda" element={<AgendaGlobal user={currentUser} />} />
            <Route path="/agenda-technicien" element={<AgendaTechnicien user={currentUser} />} />
            <Route path="/agenda-global" element={<AgendaGlobal user={currentUser} />} />
            
            {/* Réalisation */}
            <Route path="/realisation" element={<RealisationIntervention user={currentUser} />} />
            <Route path="/realisation/:id" element={<RealisationIntervention user={currentUser} />} />
            
            {/* Statistiques */}
            <Route path="/statistiques-technicien" element={<StatistiquesTechnicien user={currentUser} />} />
            <Route path="/statistiques-globales" element={<StatistiquesGlobales user={currentUser} />} />
            
            {/* Produits */}
            <Route path="/produits" element={<ListeProduits user={currentUser} />} />
            <Route path="/produits/nouveau" element={<FormulaireProduit user={currentUser} />} />
            <Route path="/produits/:id/modifier" element={<FormulaireProduit user={currentUser} />} />
            
            {/* Stocks */}
            <Route path="/stocks" element={<GestionStock user={currentUser} />} />
            <Route path="/stocks/alertes" element={<AlertesStock user={currentUser} />} />
            
            {/* Redirect */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;

